import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { CircularProgress } from "@mui/material";
import { SurveyServices } from "../services/SurveyServices";
import SurveyFormSubmissionInfo from "./SurveyFormSubmissionInfo";
import CustomPagination from "../utils/paginationUtils";
import SearchIcon from "../assets/searchIcon.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EyeIcon from "../assets/eyeIcon.svg";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";

import "./SurveyDetails.scss";

const SurveyDetails = () => {
  const [loading, setLoading] = useState(false);
  const [surveyDetails, setSurveyDetails] = useState(null);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [questionDetail, setQuestionDetail] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  let searchTimeRef = useRef();
  const limit = 10;
  const getLocation = (location) => {
    return `${location.city} ${location.state} ${location.country}`;
  };
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const getDate = (dateString) => {
    const date = new Date(dateString);

    // Format the date as DD/MM/YYYY HH:MM
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };
  const getQuetsionDetails = async () => {
    try {
      const res = await SurveyServices?.getSurveyQuestionsReport();
      console.log("question report:", res?.data);
      setQuestionDetail(res?.data?.surveyReport);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getSurveyDetails = async () => {
    setLoading(true);
    try {
      const res = await SurveyServices.getSurveyDetails(page, limit, searchKey);
      setSurveyDetails(res?.data?.data);
      setTotalPages(res?.data?.totalPages);
      console.log("survey details", res?.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getSurveyDetails();
  }, [page, searchKey]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getQuetsionDetails();
  }, []);
  console.log("qestion details:", questionDetail);
  return (
    <div className="survey-details-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Survey Details
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">SurveyDetails</div>
        <div
          style={{ border: "1px solid #E4E4E4" }}
          className="flex items-center gap-2 bg-white rounded-[8px] px-4 py-[6px]"
        >
          <img src={SearchIcon} alt="search-icon" />
          <input
            type="text"
            placeholder="Search anything"
            style={{ border: "0" }}
            className="outline-none"
            onChange={handleSearch}
          />
        </div>
      </div>
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      {loading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className={`grid grid-cols-6  text-[#797979] text-[18px] px-8`}>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Surveyor ID
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Survey Date Time
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4"> Location</div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                Hospital Name
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                User Name
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] text-center font-semibold mb-4">
                {" "}
                Survey Details
              </div>
            </div>
          </div>
          {surveyDetails && surveyDetails.length > 0 ? (
            surveyDetails?.map((survey, idx) => {
              return (
                <div
                  key={idx}
                  className={`py-6 px-8 rounded-[16px] ${
                    idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                  }`}
                >
                  <div
                    className={`grid grid-cols-6  text-[#797979] text-[18px] `}
                  >
                    <div>{survey?.surveyorId || "--"}</div>
                    <div>
                      {survey?.createdAt ? getDate(survey.createdAt) : "--"}
                    </div>
                    <div>{getLocation(survey?.location) || "--"}</div>
                    <div>{survey?.healthcareEntityName || "--"}</div>
                    <div>{survey?.name || "--"}</div>
                    <div>
                      {selectedSurvey === idx ? (
                        <SurveyFormSubmissionInfo
                          questionDetail={questionDetail}
                          survey={survey}
                          setOpen={setSelectedSurvey}
                        />
                      ) : (
                        <div className="flex justify-center items-center">
                          {/* <InfoOutlinedIcon
                            className="text-[#017C57] cursor-pointer"
                            onClick={() => setSelectedSurvey(idx)}
                          /> */}
                          <img
                            src={EyeIcon}
                            alt="eye-icon"
                            className="h-[30px] w-[30px] cursor-pointer"
                            onClick={() => setSelectedSurvey(idx)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-xl flex items-center justify-center mt-5 font-semibold h-[300px]">
              No Data Found
            </div>
          )}
        </div>
      )}
      <div className="flex justify-center items-center mt-7">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default SurveyDetails;
